export const TEST_ID = 'searchFilters';

export const SEARCH_DEBOUNCE_TIME_MS = 300;
